import { Empty } from "./Empty";

interface Props {
  itemCount: number;
  message: string;
  children: React.ReactNode;
}
export const WithEmptyList: React.FC<Props> = ({ itemCount, message, children }) => {
  if (itemCount === 0) {
    return <Empty message={message} />;
  }
  return <>{children}</>;
};
